import * as React from 'react';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';
import { withStyles, Typography, ButtonBase } from '@material-ui/core';
import classnames from 'classnames';
import TaskAvatar from './TaskAvatar';

const styles = theme => ({
    task: {
        padding: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    taskIcon: {
        marginBottom: theme.spacing(1),
    },
    underline: {
        '$task:hover &': {
            borderBottom: '1px solid',
        },
    },
});

class DragableTask extends React.Component {
    render() {
        const {
            classes, className, task, index, onClick, disabled,
        } = this.props;

        if (!module) {
            return null;
        }

        return (
            <div
                className={classnames(classes.task, className)}
            >
                <Draggable draggableId={task.id} index={index} isDragDisabled={disabled}>
                    {provided => (
                        <div
                            ref={provided.innerRef}
                            style={provided.draggableProps.style}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                        >
                            <TaskAvatar task={task} className={classes.taskIcon} />
                        </div>
                    )}
                </Draggable>
                <ButtonBase onClick={onClick}>
                    <Typography align="center" className={classes.text}>
                        <span className={classes.underline}>
                            {task.name}
                        </span>
                    </Typography>
                </ButtonBase>
            </div>
        );
    }
}

DragableTask.propTypes = {
    classes: PropTypes.object.isRequired,
    task: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
};

DragableTask.defaultProps = {
    className: null,
    onClick: null,
    disabled: false,
};

export default withStyles(styles)(DragableTask);
